export default `
  query popularCategories {
    categories {
      items{
        popular_category{
          name
          popular_category_image
          show_popular_category
          url_key
          url_path
        }
      }
    }
  }
`;
